"use client";

import type { ReactNode } from "react";
import { getSvgSkillIcon } from "@/lib/svg-skill-icons";
import { GitCommitIcon } from "@/components/icons/GitCommitIcon";
import { CodeReviewIcon } from "@/components/icons/CodeReviewIcon";
import { SearchIcon } from "@/components/icons/SearchIcon";
import { PaletteIcon } from "@/components/icons/PaletteIcon";
import { RocketIcon } from "@/components/icons/RocketIcon";
import { FileTextLinesIcon } from "@/components/icons/FileTextLinesIcon";
import { EditIcon } from "@/components/icons/EditIcon";
import { ShieldCheckIcon } from "@/components/icons/ShieldCheckIcon";
import { RefreshCwIcon } from "@/components/icons/RefreshCwIcon";
import { ZapIcon } from "@/components/icons/ZapIcon";

// Module-level icon map -- created once, reused across renders
export const SKILL_ICONS: Record<string, ReactNode> = {
  "git-commit": <GitCommitIcon width={16} height={16} />,
  "code-review": <CodeReviewIcon width={16} height={16} />,
  search: <SearchIcon width={16} height={16} />,
  palette: <PaletteIcon width={16} height={16} />,
  rocket: <RocketIcon width={16} height={16} />,
  "file-text": <FileTextLinesIcon width={16} height={16} />,
  edit: <EditIcon width={16} height={16} />,
  "shield-check": <ShieldCheckIcon width={16} height={16} />,
  "refresh-cw": <RefreshCwIcon width={16} height={16} />,
};

export const SKILL_ICON_DEFAULT = <ZapIcon width={16} height={16} />;

export function getSkillIcon(iconName?: string): ReactNode {
  // Check for svg: prefix icons (system skills like svg:agents, svg:skills, svg:routines)
  const svgIcon = getSvgSkillIcon(iconName);
  if (svgIcon) return svgIcon;

  return SKILL_ICONS[iconName || ""] || SKILL_ICON_DEFAULT;
}
